import { AppVersionDialog } from '@/components/layout/app-version/app-version-dialog'
import { CartMini } from '@/components/layout/header/cart-mini'
import { Container } from '@/components/ui/container'
import { useVersionDialog } from '@/hooks/use-version-dialog'
import { cn } from '@/lib/utils'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import Link from 'next/link'
import { SearchBar } from '../search-bar'
import { MobileNav } from './mobile-nav/mobile-nav'
import { MainNav } from './navigation-menu'
const RollingNames = dynamic(
  () => import('./rolling-names').then((mod) => mod.RollingNames),
  {
    ssr: false,
    loading: () => (
      <div className='flex items-center text-[15px] font-extrabold uppercase tracking-wide md:text-base'>
        <div className='h-[1.2em] w-[68px]' />
        <span className='ml-1 rounded-sm bg-neutral-900 px-1 py-0 text-white'>
          Mate
        </span>
      </div>
    ),
  }
)

const isRollingNamesEnabled =
  process.env.NEXT_PUBLIC_ROLLING_NAMES_ENABLED === 'true'

const UserMenu = dynamic(
  () => import('./user-menu').then((mod) => mod.UserMenu),
  {
    ssr: false,
    loading: () => (
      <div className='flex h-13 w-10.5 items-center justify-center'>
        <div className='h-5 w-5' />
      </div>
    ),
  }
)

export const Navbar = ({
  isMobile,
  isTopBarPromotionHidden,
}: {
  isMobile?: boolean
  isTopBarPromotionHidden?: boolean
}) => {
  const { isOpen, handleRapidClick, handleOpenChange } = useVersionDialog()

  const handleLogoClick = (e: React.MouseEvent) => {
    const isRapidClick = handleRapidClick()
    if (isRapidClick) {
      // Nếu là rapid click, chúng ta mới chặn hành vi mặc định để mở dialog
      e.preventDefault()
    }
    // Nếu không, cứ để Link hoạt động bình thường, không cần router.push
  }

  return (
    <div
      className={cn(
        'h-13 bg-background shadow-sm lg:h-17',
        isTopBarPromotionHidden && 'border-b border-b-neutral-300'
      )}
    >
      <Container size='full' className='h-full'>
        <div className='relative flex h-full items-center justify-between'>
          {isMobile && (
            <div className='flex flex-1 items-center text-neutral-800'>
              <MobileNav />

              <SearchBar isMobile />
            </div>
          )}

          <figure
            className={cn(
              'flex flex-1',
              isMobile ? 'justify-center' : 'lg:justify-start'
            )}
          >
            <Link
              href={'/'}
              className='flex flex-col items-center gap-0.5'
              onClick={handleLogoClick}
              ga-tracking-value='navbar__logo'
              ga-tracking-label='logo'
            >
              {isRollingNamesEnabled ? (
                <RollingNames />
              ) : isMobile ? (
                <Image
                  src={'/images/logo-mobile.svg'}
                  alt='Logo Coolmate Mobile'
                  width={36}
                  height={33}
                  priority={isMobile}
                />
              ) : (
                <Image
                  src={'/images/logo.png'}
                  alt='Logo Coolmate'
                  width={90}
                  height={50}
                  priority={!isMobile}
                  className='min-w-[90px]'
                />
              )}
            </Link>
          </figure>
          {!isMobile && <MainNav />}

          <div className='flex flex-1 items-center justify-end text-neutral-800'>
            {!isMobile && (
              <div className='lg:w-52 xl:w-[280px]'>
                <SearchBar />
              </div>
            )}

            <UserMenu />
            <CartMini />
          </div>
        </div>
      </Container>

      <AppVersionDialog open={isOpen} onOpenChange={handleOpenChange} />
    </div>
  )
}
